import React, {useCallback, useState} from 'react';
import {Button, Container, Col, Row} from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';
import {blockquotes} from './data.json';
import './Blockquote.scss';

function BlockquoteItem({id, cite, text, image, cols, backgroundColor, borderColor, textColor, ...props}) {
  return (
    <Row className={classNames('blockquote-item d-flex align-items-center justify-content-center', props.className)}>
      <Col xs="7" sm="5" lg="3" className="mb-3 mb-lg-0">
        <img className="blockquote-img img-fluid rounded-circle" src={image}/>
      </Col>
      <Col xs="12" lg="8" className="text-700 text-h4 text-center text-lg-left">
        <p className="text-italic">{text}</p>
        <p className="mb-0">— {cite}</p>
      </Col>
    </Row>
  );
}

export default function Blockquote({id, ...props}){
  const blockquote = blockquotes.find(e => e.id === id);
  return blockquote ? <BlockquoteItem {...blockquote} {...props} /> : null;
}
